import React from 'react';
import { List, Button, Spin, Tag } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { formatStudentName } from './ChatTranscript';

const ConversationSidebar = ({
  conversations,
  selectedId,
  onSelect,
  loading,
  onRefresh,
}) => (
  <div className="ai-coach-sidebar">
    <Button
      className="ai-coach-sidebar-refresh"
      icon={<ReloadOutlined />}
      onClick={onRefresh}
      loading={loading}
      block
    >
      Refresh
    </Button>
    <Spin spinning={loading}>
      <List
        className="ai-coach-sidebar-list"
        dataSource={conversations}
        locale={{ emptyText: 'No conversations' }}
        renderItem={(item) => {
          const isSelected = item.conversation_id === selectedId;
          return (
            <List.Item
              key={item.conversation_id}
              className={`ai-coach-sidebar-item${isSelected ? ' ai-coach-sidebar-item--selected' : ''}`}
              onClick={() => onSelect(item.conversation_id)}
            >
              <List.Item.Meta
                title={
                  <div className="ai-coach-sidebar-item__title-row">
                    <span className="ai-coach-sidebar-item__name">
                      {formatStudentName(item)}
                    </span>
                    {item.escalated === true && (
                      <Tag color="volcano" className="ai-coach-sidebar-item__badge">
                        Escalated
                      </Tag>
                    )}
                  </div>
                }
                description={
                  <>
                    <div className="ai-coach-sidebar-item__preview">
                      {item.last_message_preview || 'No messages yet'}
                    </div>
                    {item.last_message_at && (
                      <span className="ai-coach-sidebar-item__time">
                        {moment(item.last_message_at).fromNow()}
                      </span>
                    )}
                  </>
                }
              />
            </List.Item>
          );
        }}
      />
    </Spin>
  </div>
);

export default ConversationSidebar;
